<template>
  <div class="section grid-wrapper">
    <cargo-ag-grid
      config-module="190809"
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="`min-height: ${gridHeight};`"
      :auto-fit-content="false"
    />
  </div>
</template>

<script>

import { queryBillPaymentApproveHistory } from '@/api/clearing/billPayment.js'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'ApprovalHistoryDialog',
  props: {
    billPaymentUuid: { type: String, required: true },
    gridHeight: { type: String, default: '540px' },
    approveHistoryJc: { type: Boolean, default: false },
    // CARGO-30641 付款申请审批时可以填写审批备注，【付款申请】模块添加【审批历史】页签
    approveHistoryPlatform: { type: Boolean, default: false }
  },
  data() {
    return {
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      // 请求详情body
      queryBody: {
        billPaymentUuid: 0,
        approveHistoryJc: this.approveHistoryJc,
        approveHistoryPlatform: this.approveHistoryPlatform
      },
      isItACommercialAudit: false
    }
  },
  computed: {
    columnDefs() {
      return [
        { headerName: this.$t('Payment.approveTime'), field: 'approveDate', width: 180 },
        { headerName: this.$t('Payment.approveHistoryNode'), field: 'approveNode', width: 150,
          valueFormatter: params => {
            if (this.isItACommercialAudit && params.data && params.data.approveNode === '业务审批') {
              return ColumnUtils.billPaymentApprovalNodeLabelFunc('商务审批')
            }
            const label = ColumnUtils.billPaymentApprovalNodeLabelFunc(params.value)
            if (label) {
              return label
            }
            return params.value
          } },
        { headerName: this.$t('Payment.operator'), field: 'approveByChineseName', width: 150 },
        { headerName: this.$t('Payment.approval_results'), field: 'approveStateDesc', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentApprovalResultsLabelFunc(params.data)
          }
        },
        { headerName: this.$t('Payment.paymentRequestState'), field: 'approvedBillPaymentState', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentStateLabelFuncNullStr(params.value)
          }
        },
        { headerName: this.$t('Payment.remarks'), field: 'remark', width: 150 }
      ]
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isItACommercialAudit = Number(cache.config.get('IsItACommercialAudit')) === 1
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    // 初始化装载 审批历数据
    loadData() {
      console.log('this.approveHistoryPlatform:' + this.approveHistoryPlatform)
      this.queryBody.billPaymentUuid = this.billPaymentUuid
      queryBillPaymentApproveHistory(this.queryBody).then(res => {
        console.log(res)
        this.rowData = (res.data === '') ? [] : res.data
      })
    }
  }
}
</script>

<style lang="scss">
</style>
